import { createScreenStyles } from '../../theme/styles';
import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  KeyboardAvoidingView,
  Text,
  StyleSheet,
  TouchableHighlight,
  Dimensions,
  ActivityIndicator,
  Alert,
  TextInput,
  Platform
} from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Entypo } from '@expo/vector-icons';
const screenWidth = Math.round(Dimensions.get("window").width);
const screenHeight = Math.round(Dimensions.get("window").height);

export function isIphoneX() {
  return Platform.OS === "ios" && screenHeight >= 812;
}

export function isAndroid() {
  return Platform.OS !== "ios";
}

export default function checklist({ route, navigation }) {

  const {checkId} = route.params;
  const [userid, setUserid] = useState('');
  const [usernome, setUsernome] = useState('');
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState("");
  const [status, setStatus] = useState("");
  const [status_comm, setStatus_comm] = useState('');
  const [docs, setDocs] = useState([]);
  const [itens, setItens] = useState([]);

  async function getStorageValue() {
    setUserid(await AsyncStorage.getItem('sfuserid'));
    setUsernome(await AsyncStorage.getItem('sfusernome'));
  }
  
  async function loadItens() {
    setLoading(true);
    const response = await fetch(
      'https://superfrio-back-dev.vercel.app/checklistpititem/checklist/' + checkId
    );

    const data = await response.json();
    setItens(data);
    setLoading(false);
  };

  async function loadHeader() {
    const response = await fetch(
      'https://superfrio-back-dev.vercel.app/checklistpit/' + checkId
    );

    const data = await response.json();
    setDocs(data);
    setStatus(data[0].status);
    setComments(data[0].comentarios)
    if(data[0].status_comm)
    setStatus_comm(data[0].status_comm);
  };

  async function save(){
    const response = await fetch(
      'https://superfrio-back-dev.vercel.app/checklistpititem/checklist/' + checkId
    );
    const data = await response.json();

    for(let i=0; i < data.length; i++) {
      if(data[i].avaliacao == undefined) { 
        validaChecklist(data[i].ordemitem, data[i].nomeitem, 'avaliação')
        return;
      }
      if(!data[i].foto) { 
        validaChecklist(data[i].ordemitem, data[i].nomeitem, 'foto')
        return;
      }
   }
   
   Alert.alert(
    "Confirmação",
    "Você confirma o envio do Checklist para aprovação ?",
    [
      {
        text: "Cancelar",
        onPress: () => console.log("Cancel Pressed"),
        style: "cancel"
      },
      { text: "Sim", onPress: () => confirmSubmit() }
    ],
    { cancelable: false }
  );

    
    // Check if all items are reviewed, comments and photo uploaded
    // Change status to 'in review' and allow administrator to approve and generate PDF on front-end
  };

  async function confirmSubmit(){

   setLoading(true);
   
   const responsePut = await fetch(
    'https://superfrio-back-dev.vercel.app/checklistpit/' + checkId,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        status: 1,
        idusuario: userid,
        nomeusuario: usernome,
        comentarios: comments,
        status_comm: ''
      }),
    }
  );

  const dataPut = await responsePut.json();

  if (responsePut.ok) {
    Alert.alert(
      "Sucesso",
      "Checklist enviado com sucesso !",
      [
        {
          text: "Fechar",
          style: "cancel"
        },
      ],
      { cancelable: false }
    );
    setLoading(false);
    navigation.navigate('PitStop');
  } else {
    setLoading(false);
    alert("error " + dataPut);
  }
  }

  function validaChecklist(ordemitem, nomeitem, tipo){
    Alert.alert(
      "Atenção",
      "Revisar " + tipo + " do item " + ordemitem + " - " + nomeitem,
        {
          text: "OK",
          style: "cancel"
        },
      { cancelable: false }
    );
  };

  useEffect(() => {
    setLoading(true);
    loadHeader();
    loadItens();
    getStorageValue();
    setLoading(true);
  }, []);   
    
  return (
    <KeyboardAvoidingView
    behavior={Platform.OS === "ios" ? "padding" : "height"}
    style={styles.container}
  >
      
      <ScrollView>
      {loading && (
            <ActivityIndicator size="large" color="#0000ff" style={styles.LoadingIndicator} />
          ) 
      }
      {docs.map(docs => 
          <View key={docs._id}>
           
            <View style={styles.headerContainer}>
              <Text numberOfLines={1} style={styles.textDescBold2}>Informações do PitStop</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Data de Entrada: </Text>{docs.dataentrada.substring(8,10) + "/" + docs.dataentrada.substring(5,7) + "/" + docs.dataentrada.substring(0,4)}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Tipo: </Text>{docs.tipo}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Controle ID: </Text>{docs.controlid}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>N. Serie CF: </Text>{docs.nserie}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>CNPJ: </Text>{docs.CNPJ}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Razão Social: </Text>{docs.rsocial}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Status: </Text>{docs.status == '0' ? "Pendente" : docs.status == '1' ? "Processando" : "Concluído"}</Text>
            </View>
          </View>
     )}

      {status_comm != '' && status == '0' &&
        <View style={styles.headerContainer}>  
          <Text style={styles.textDesc}><Text style={styles.textDescBold}>Rejeitado: </Text>{status_comm}</Text>
        </View>
      }

      {itens.map(itens => 
          <TouchableHighlight
          underlayColor={"#a5a5a5"}
          style={styles.highlight}
          key={itens._id}
          onPress={() => {navigation.navigate("AvaliarPit", { nomeitem: itens.nomeitem, iditem: itens._id, status:docs[0].status ,refresh: loadItens}) }}>
          
          <View style={styles.containerGeral}>
            <View style={styles.txtContainerRow}>
              
              <View style={styles.divCounter}>
                <Text numberOfLines={1} style={styles.textDescBold}>{itens.ordemitem}</Text>
              </View>

              <View style={styles.divMiddle}>
                <Text numberOfLines={1} style={styles.textDescBold}>{itens.nomeitem}</Text>
                <Text numberOfLines={1} style={itens.avaliacao == null ? styles.textDescPend : styles.textDescOk}>{itens.avaliacao == null ? "Pendente Avaliação" : "Item Avaliado"}</Text>
                <Text numberOfLines={1} style={itens.foto == null ? styles.textDescPend : styles.textDescOk}>{itens.foto == null ? "Pendente Foto" : "Foto Salva"}</Text>
              </View>

              <View style={styles.divIcon}>
              <Entypo name={'chevron-right'} style={styles.searchIconReset} size={18} color="#b2b2b2" />  
              </View>

            </View>
          </View>
        </TouchableHighlight>
      )}

      <TextInput
        style={styles.textSearch}
        placeholder={status < 1 ? "Digite suas observações": ""}
        placeholderTextColor="#484848"
        maxLength={200}
        editable={status < 1}
        multiline={true}
        autoCorrect={false}
        autoCapitalize="sentences"
        value={comments}
        onChangeText={setComments}
      />

      {status < 1 && 
        <TouchableHighlight
          underlayColor={"#fff"}
          style={styles.headerContainer}
          onPress={() => save()}
        >
       
          <View style={styles.buttonDoneBig}>
            <Text style={styles.buttonText}>Enviar Checklist</Text>
          </View>

        </TouchableHighlight>
      }
      <View>
      <Text></Text>
      <Text></Text>
      </View>
    

      </ScrollView>
    </KeyboardAvoidingView>

    // <View style={styles.container}>

    //     <View style={styles.containerGeral}>

    //       {/* <TextInput
    //           style={styles.textSearch}
    //           placeholder='Digite suas observações'
    //           placeholderTextColor="gray"
    //           maxLength={200}
    //           multiline={true}
    //           autoCapitalize='sentences'
    //           value={comments}
    //           onChangeText={setComments}
    //         /> */}

    //       {/* <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('Camera') }}>
    //         <View style={styles.menuItem}>
    //           <Text style={styles.textMenu}>Adicionar Foto</Text>
    //         </View>
    //       </TouchableHighlight>

    //       <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('Checklist2Compressor') }}>
    //         <View style={styles.menuItem}>
    //           <Text style={styles.textMenu}>Próximo Item</Text>
    //         </View>
    //       </TouchableHighlight> */}

    //     </View>

    // </View>
  );
}

var styles = createScreenStyles({
  container: {
    flex: 1,
    backgroundColor: "#d5d5d5",
  },

  LoadingIndicator: {
    flex: 1,
    justifyContent: "center",
    marginTop: 15,
  },

  ItemImg: {
    backgroundColor: "#fff",
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 4,
    marginLeft: screenWidth * 0.025,
    marginRight: screenWidth * 0.025,
  },

  menuItem: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "green",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemG: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "green",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemY: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "#CC6600",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemR: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "red",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  textDescPend: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#fa9200'
  },

  textDescOk: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#4ead31'
  },


  textMenu: {
    color: "#fff",
    fontSize: 16,
  },

  textSearch: {
    width: '97%',
    paddingLeft: 10,
    marginLeft:5,
    color: "#484848",
    height: 100,
    marginTop: screenHeight * 0.01,
    marginBottom: screenHeight * 0.01,
    backgroundColor: "#fff",
    borderColor: "#d3d3d3",
    borderWidth: 1,
    borderRadius: 5,
  },

  textEmpty: {
    fontSize: 14,
    fontWeight: "300",
    color: "#484848",
    marginLeft: screenWidth * 0.025,
    marginTop: 10,
    textAlign: "center",
  },

  textDesc: {
    fontSize: 14,
    paddingTop: 5,
  },

  textDescBold: {
    fontSize: 14,
    paddingTop: 5,
    fontWeight: "bold",
  },

  textDescBold2: {
    fontSize: 14,
    marginBottom:5,
    fontWeight: "bold",
    textAlign:'center'
  },

  textDescBold3: {
    fontSize: 15,
    marginBottom:5,
    fontWeight: "bold",
    textAlign:'center',
    color:'#484848'
  },

  textDescAberto: {
    fontSize: 12,
    paddingTop: 5,
    color: "green",
  },

  containerGeral: {
    backgroundColor: "#fff",
    paddingLeft: 10,
    paddingBottom: 10,
    borderRadius: 3,
  },

  txtContainer: {
    width: '90%',
    marginTop: 5,
  },


  txtContainerRow: {
    flexDirection:'row',
    marginTop: 5,
  },

  headerContainerInt:{
    marginTop:5,
    marginLeft:5,
    marginRight:5,
    padding:10
  },

  headerContainer:{
    backgroundColor:'#fff',
    marginTop:5,
    marginLeft:5,
    marginRight:5,
    padding:10
  },

  highlight: {
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    borderWidth:1,
    borderColor:'#999999'

  },

  buttonDoneBig:{
    backgroundColor:'#336633',
    marginTop: 5,
    height:60,
    width: '90%',
    justifyContent:'center',
    borderRadius:10
  },

  buttonDone:{
    backgroundColor:'#336633',
    marginTop: 5,
    height:30,
    width: '90%',
    justifyContent:'center'
  },

  buttonPend:{
    backgroundColor:'#993333',
    marginTop: 5,
    height:30,
    width: '90%',
    justifyContent:'center'
  },

  buttonText:{
    textAlign:'center',
    color:'#fff'
  },


  divCounter:{
    width: '7%',
    justifyContent:'center',
    borderRightWidth:1,
    borderRightColor:'#a1a1a1'
  },

  divMiddle:{
    width: '72%',
    borderRightWidth:1,
    borderRightColor:'#a1a1a1',
    paddingLeft:10
  },

  divIcon:{
    width: '10%',
    justifyContent:'center',
    alignSelf:'center',
    alignItems:'center'
  }


});
